import { queryApi, numberFormat, formatPrice } from '@utils';

document.addEventListener("minicartRemoveRow", async event => {
	try {
		await queryApi("removeItem", {
			lang: hmk_rest_var.lang,
			cartItemID: event.detail
		}).then(response => {
			document.querySelector('.header__cart-count').textContent = response.count;
			
			const bdiElement = document.querySelector('.header__cart-total bdi');
			
			if (bdiElement && bdiElement.childNodes[1]) {
				bdiElement.childNodes[1].nodeValue = numberFormat(response.total, hmk_rest_var.decimals, hmk_rest_var.decimal_separator, hmk_rest_var.thousand_separator);
			}
			
			response.total = formatPrice(response.total);
			
			const minicartEvent = new CustomEvent("minicartRowRemoved", {
				detail: response
			});
			document.dispatchEvent(minicartEvent);
		});
	} catch (error) {
		console.error("Failed to remove item:", error);
	}
});
